import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ATS_AccountEditor.scss';
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_AccountEditor } from '../../account-editor/Component_AccountEditor.js';
import { generateUUID } from '@nu-art/ts-common';
import { ModuleFE_Account } from '../../_entity/account/index.js';
export class ATS_AccountEditor extends ComponentSync {
    static screen = {
        name: 'Accounts Editor',
        key: 'user-account',
        renderer: this,
        group: 'Permissions',
        modulesToAwait: [ModuleFE_Account]
    };
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = this.state ? { ...this.state } : {};
        return state;
    }
    // ######################### Logic #########################
    setSelectedAccount = (account) => {
        if (!account)
            this.setState({ isPreview: false, selectedUser: undefined });
        else
            this.setState({ isPreview: true, selectedUser: account });
    };
    render() {
        return _jsxs(LL_H_C, { className: 'account-editor-form', children: [_jsx(Component_AccountList, { user: this.state.selectedUser, setSelectedAccount: this.setSelectedAccount }), _jsx(Component_AccountEditor, { isPreview: this.state.isPreview, user: this.state.selectedUser })] });
    }
}
class Component_AccountList extends ComponentSync {
    __onAccountsUpdated(...params) {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state.list = ModuleFE_Account.cache.allMutable();
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'form-container account-list', children: [_jsx(LL_H_C, { className: 'match_width', children: _jsx(TS_PropRenderer.Horizontal, { className: 'match_width', label: 'Accounts List', children: _jsx(Button, { variant: 'primary', onClick: async () => this.props.setSelectedAccount(), children: "Create Account" }) }) }), _jsx(LL_V_L, { className: 'match_width users-list', children: this.state.list.map(account => {
                        const className = _className('match_width', 'row', this.props.user?._id === account._id && 'selected');
                        return _jsx(TS_PropRenderer.Horizontal, { onClick: () => this.props.setSelectedAccount(account), className: className, label: account.email }, generateUUID());
                    }) })] });
    }
}
//# sourceMappingURL=ATS_AccountEditor.js.map